import LiveChannelShelf from "../../components/cinema/LiveChannelShelf";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import "../../components/cinema/KidsCatalog.scss";
import { getKidsCopy, isKidsMenu } from "../../components/cinema/kidsTheme";
import { useCatalogMenuTheme } from "../../components/cinema/CatalogTheme";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ErrorState, LoadingState } from "../../components/status/StatusView";
import { loadRequest } from "../../utils/loadRequest";
import Mainboard from "../../components/mainboard";
import DeferredShelf from "../../components/cinema/DeferredShelf";
import { SessionContext } from "../../context/SessionContext";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Carousel from "../../components/carousel";
import CategoryCarousel from "../../components/categoryCarousel";
import ContentGrid from "../../components/contentGrid/ContentGrid";
import ModalRouting from "../../components/modalRouting/ModalRouting";
import Record from "../record/Record";
import { ChannelCarousel } from "../../components/channelCarousel/ChannelCarousel";
import {
  childMenuId,
  getIsFromPip,
  setIsFromPip,
  specialForMeId,
  specialForMeKidId
} from "../../statics/config";
import useQuery from "../../utils/useQuery";
import MiniVodDetail from "../../components/miniVodDetail/MiniVodDetail";
import MiniProgramDetail from "../../components/miniProgramDetail/MiniProgramDetail";
import {
  getCategoriesById,
  getLabelsById
} from "../../api/category/categoryApi";
import { getCatchupsByLabel } from "../../api/catchup/catchup";
import { getRecommendationsForUser } from "../../api/vod/vod";

const Home = () => {
  const copy = getCinemaCopy();
  const [labels, setLabels] = useState([]);
  const [directContents, setDirectContents] = useState([]);
  const [
    { items: categories, menuId: categoryMenuId, name: menuName },
    setCategoryData
  ] = useState({
    items: [],
    menuId: null,
    name: ""
  });
  const [bannerPosition, setBannerPosition] = useState(null);
  const [recordRefreshCounter, setRecordRefreshCounter] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showMiniVodDetail, setShowMiniVodDetail] = useState(false);
  const [showMiniProgramDetail, setShowMiniProgramDetail] = useState(false);
  const [mainBoardVods, setMainBoardVods] = useState(null);
  const [lastWatchedChannelsId, setLastWatchedChannelsId] = useState(null);

  const { setPath, setSelectedMenuId, profile } = useContext(SessionContext);
  const allVodColumns = useRef([]);
  const columnCounter = useRef(1);
  const history = useHistory();
  let { menuId, categoryId } = useParams();
  const categoryIdRef = useRef(categoryId);
  categoryIdRef.current = categoryId;
  let { url } = useRouteMatch();
  let isFromPip = getIsFromPip();
  const previewData = useRef({});
  const libraryRef = useRef(null);
  const isLeftRef = useRef(null);
  const isRightRef = useRef(null);
  const programPreviewData = useRef({});
  const menuIdRef = useRef(null);
  const recommendedLabelRef = useRef(null);
  const labelRequest = useRef(0);
  const categoryRequest = useRef(0);
  const [loadError, setLoadError] = useState(false);
  const [loadAttempt, setLoadAttempt] = useState(0);
  const [labelsLoading, setLabelsLoading] = useState(false);
  const isMain =
    menuId === "mw-home" ||
    (categoryMenuId === menuId && categories[0]?.isMain === true);
  const isKids = categoryMenuId === menuId && isKidsMenu(menuName);
  useCatalogMenuTheme(categoryMenuId === menuId ? menuId : null, menuName);
  const browseLibrary = () => {
    if (libraryRef.current)
      libraryRef.current.scrollIntoView({ block: "start" });
  };

  useEffect(() => {
    if (profile) {
      !profile && history.replace("/login");
    }
  }, []);

  useEffect(() => {
    labels.forEach((label) => {
      if (label?.id === 77) {
        setLastWatchedChannelsId(label?.id);
      }
    });
  }, [labels]);

  const getLabels = async (id) => {
    const requestId = ++labelRequest.current;
    // Check if this is the catchup category (Watch again with ID 45)
    if (id === "45") {
      await getCatchupLabels(requestId);
      return;
    }

    const { data } = await loadRequest((options) => getLabelsById(id, options));
    if (!menuIdRef.current || requestId !== labelRequest.current) return;
    if (!Array.isArray(data?.labels))
      throw new Error("Invalid shelves response");
    if (data.labels) {
      allVodColumns.current = data.labels;
      allVodColumns.current = allVodColumns.current.sort(
        (a, b) => b.priority - a.priority
      );
      // setLabels(allVodColumns.current.slice(0, 5));

      const mapRecommendationItemToVod = (item) => {
        const id =
          item?.contentUId ||
          item?.contentUid ||
          item?.ContentUId ||
          item?.contentId ||
          item?.uid ||
          item?.id;
        const posterUrl =
          item?.posterImageUrl ||
          item?.PosterImageUrl ||
          item?.posterUrl ||
          null;

        return {
          id,
          title: item?.title || item?.Title || "",
          type: item?.type || item?.Type || "MOVIE",
          year: item?.year || item?.releaseYear || item?.ReleaseYear || null,
          duration: item?.duration || item?.Duration || null,
          posters: posterUrl
            ? [
                {
                  type: "Web Portrait",
                  url: posterUrl,
                  posterType: "HorizontalLow",
                  posterUrl: posterUrl
                },
                {
                  type: "Web Landscape",
                  url: posterUrl,
                  posterType: "HorizontalLow",
                  posterUrl: posterUrl
                }
              ]
            : []
        };
      };

      // The catalogue is usable even if optional recommendations are unavailable.
      setLabels(data.labels);
      setDirectContents(data.contents || []);
      let recommendationLabel = null;
      if (isMain === true || id === "mw-home") {
        if (recommendedLabelRef.current?.contents?.length) {
          recommendationLabel = recommendedLabelRef.current;
        } else {
          try {
            const response = await loadRequest((options) =>
              getRecommendationsForUser(12, options)
            );
            const payload =
              response?.data?.Data ?? response?.data?.data ?? response?.data;
            const items = Array.isArray(payload)
              ? payload
              : Array.isArray(payload?.Data)
              ? payload.Data
              : Array.isArray(payload?.data)
              ? payload.data
              : Array.isArray(payload?.items)
              ? payload.items
              : Array.isArray(payload?.Items)
              ? payload.Items
              : [];

            const normalized = items
              .map(mapRecommendationItemToVod)
              .filter((item) => !!item?.id);

            if (normalized.length > 0) {
              recommendationLabel = {
                id: "recommendedforuser",
                name: "Onerilenler",
                priority: 12,
                type: "RECOMMENDATION_USER",
                vertical: true,
                contents: normalized
              };
              recommendedLabelRef.current = recommendationLabel;
            }
          } catch (e) {
            recommendationLabel = null;
          }
        }
      }

      let mergedLabels = [...data.labels];
      if (recommendationLabel) {
        mergedLabels = [recommendationLabel, ...mergedLabels];
      }

      if (isMain === true || id === "mw-home") {
        mergedLabels = [
          ...mergedLabels,
          { id: "userrecords", name: "Records", priority: 11 }
        ];
      }
      if (!menuIdRef.current || requestId !== labelRequest.current) return;
      setLabels(mergedLabels);
    }
  };

  const getCatchupLabels = async (requestId) => {
    try {
      // Fetch catchup content from label 176 as specified
      const { data } = await loadRequest((options) =>
        getCatchupsByLabel(176, 0, 16, options)
      );
      if (!menuIdRef.current || requestId !== labelRequest.current) return;

      if (!Array.isArray(data?.catchups))
        throw new Error("Invalid catchup response");
      if (data.catchups.length > 0) {
        // Transform catchup data into label format that the carousel expects
        const catchupLabel = {
          id: "catchups_176",
          name: "Watch Again",
          priority: 1,
          contents: data.catchups,
          catchups: data.catchups, // Keep original structure
          type: "CATCHUP"
        };

        allVodColumns.current = [catchupLabel];
        setLabels([catchupLabel]);
      } else {
        // No catchup content available
        setLabels([]);
      }
    } catch (error) {
      if (requestId === labelRequest.current && menuIdRef.current) {
        setLoadError(error);
        setLabels([]);
      }
    }
  };

  const getCategories = async (id) => {
    const requestId = ++categoryRequest.current;
    const { data } = await loadRequest((options) =>
      getCategoriesById(id, options)
    );
    if (menuIdRef.current !== id || requestId !== categoryRequest.current)
      return;
    if (!Array.isArray(data?.categories)) {
      throw new Error("Invalid categories response");
    }
    if (!!data?.categories) {
      setCategoryData({
        items: data.categories,
        menuId: id,
        name: data.name || ""
      });
      setMainBoardVods(data?.banners || []);
      setDirectContents(data.contents || []);

      // A late menu response must not replace a category chosen while it loaded.
      if (categoryIdRef.current === "all" && data.categories.length) {
        let directionData = sessionStorage.getItem("datainfo");
        if (directionData && directionData !== "null" && directionData !== "") {
          let dataInfo = decodeURIComponent(directionData).split("|");
          sessionStorage.removeItem("datainfo");
          switch (dataInfo[0]) {
            case "0":
              history.push(
                `/dashboard/home/${dataInfo[1].substring(
                  0,
                  4
                )}/${dataInfo[1].substring(0, 6)}`
              );
              break;
            case "1":
              history.push(
                `/dashboard/home/${menuId}/${data?.categories[0]?.id}/voddetail/${dataInfo[1]}`
              );
              break;
            case "14":
              history.push(
                `/dashboard/home/${menuId}/${data?.categories[0]?.id}/voddetail/${dataInfo[1]}`
              );
              break;
            case "2":
              history.push(`/dashboard/livetv/${dataInfo[1]}`);
              break;
            default:
              history.push(
                `/dashboard/home/${menuId}/${data?.categories[0]?.id}`
              );
              break;
          }
        } else {
          history.push(`/dashboard/home/${menuId}/${data?.categories[0]?.id}`);
        }
      }
    }
  };

  useEffect(() => {
    let active = true;
    if (!!menuId) {
      menuIdRef.current = menuId;
      setSelectedMenuId(menuId);
      setPath(url);
      setCategoryData({ items: [], menuId: null, name: "" });
      setLabels([]);
      setDirectContents([]);
      setLabelsLoading(false);
      setMainBoardVods(null);
      setLoadError(false);
      window.scrollTo(0, 0);
      getCategories(menuId).catch((error) => {
        if (active && menuIdRef.current === menuId) {
          setLoadError(error);
          setMainBoardVods([]);
        }
      });
      //findBannerPosition(menuId);
    }
    return () => {
      active = false;
      menuIdRef.current = null;
      categoryRequest.current++;
      labelRequest.current++;
      setSelectedMenuId(null);
    };
  }, [menuId, loadAttempt]);

  useEffect(() => {
    let active = true;
    if (!!categoryId && categoryMenuId === menuId && categories.length) {
      setLabels([]);
      setDirectContents([]);
      allVodColumns.current = [];
      if (categories.some((category) => String(category.id) === categoryId)) {
        columnCounter.current = 1;
        setLoadError(false);
        setLabelsLoading(true);
        getLabels(categoryId)
          .catch((error) => {
            if (active && menuIdRef.current) setLoadError(error);
          })
          .finally(() => {
            if (active) setLabelsLoading(false);
          });
        setPath(url);
      } else if (!!categories?.length && categories?.length > 0) {
        history.replace(`/dashboard/home/${menuId}/${categories[0].id}`);
      }
    }
    return () => {
      active = false;
      labelRequest.current++;
    };
  }, [menuId, categoryId, categories, categoryMenuId]);

  useEffect(() => {
    if (isFromPip) {
      let obj = {};
      obj.record = isFromPip;
      obj.isPlay = true;
      setSelectedRecord(obj);
      setIsFromPip(null);
    }
  }, [isFromPip]);

  const renderedCarouselList = labels?.map((item, index) => {
    return (
      <DeferredShelf key={item.id} eager={index < 2}>
        <div>
          {item.id === "userrecords" ? (
            <Record
              onHoverProgramItem={(isShow, data) => {
                if (isShow) {
                  programPreviewData.current = data;
                }
                setShowMiniProgramDetail(isShow);
              }}
              recordRefreshCounter={recordRefreshCounter}
              selectedRecordItem={selectedRecord}
              setSelectedRecordItem={(val) => setSelectedRecord(val)}
            />
          ) : (
            <Carousel
              label={item}
              dontUseGrid={item?.id === "recommendedforuser"}
              onHoverItem={(isShow, data, isLeft, isRight) => {
                if (isShow) {
                  previewData.current = data;
                  isLeftRef.current = isLeft;
                  isRightRef.current = isRight;
                }
                setShowMiniVodDetail(isShow);
              }}
            />
          )}
        </div>
      </DeferredShelf>
    );
  });

  let hasGradient =
    profile?.kid || +menuId === childMenuId || +menuId === specialForMeKidId;

  return (
    <main className={`cinema-home${isKids ? " kids-catalog" : ""}`}>
      <Mainboard
        bannerPosition={bannerPosition}
        mainBoardVods={mainBoardVods}
        onBrowse={browseLibrary}
        presentation={isKids ? getKidsCopy() : undefined}
      />
      {loadError && (
        <ErrorState
          size="compact"
          error={loadError}
          onRetry={() => setLoadAttempt((value) => value + 1)}
        />
      )}
      <div className="cinema-library" ref={libraryRef}>
        {/* ${hasGradient ? "child-container" : ""} */}
        {/* {hasGradient ? <div className="child-gradient"></div> : null} */}

        {!isMain && <CategoryCarousel items={categories} />}
        {/*Genre carousel */}
        {+menuId === specialForMeId && (
          <div>
            <ChannelCarousel labelId={lastWatchedChannelsId} />
          </div>
        )}

        <div className="cinema-shelves">
          {!loadError &&
            !labels.length &&
            !directContents.length &&
            (mainBoardVods === null || labelsLoading) && (
              <LoadingState size="compact" variant="shelf" />
            )}
          {!loadError &&
            !labelsLoading &&
            categoryMenuId === menuId &&
            mainBoardVods !== null &&
            !labels.length &&
            !directContents.length && <p role="status">{copy.noItems}</p>}
          {!!directContents.length && (
            <ContentGrid items={directContents} posterPosition={7} />
          )}
          {renderedCarouselList.slice(0, 2)}
          {isMain && !!labels.length && (
            <DeferredShelf>
              <LiveChannelShelf />
            </DeferredShelf>
          )}
          {renderedCarouselList.slice(2)}
        </div>
      </div>
      <ModalRouting />
      {/* {showBannerAd ? (
        <div
          className={
            showBannerAd ? "advertisement-box show" : "advertisement-box hide"
          }
        >
          <BannerAd
            key="home-banner-ad"
            bannerId="home-banner-ad"
            configShowAd={userFrameConfig?.showGoogleAD === "1"}
            userInfo={userInfo}
            bannerConfig={homeBannerAdConfig}
            setShowBannerAd={(val) => {
              setShowBannerAd(val);
            }}
            isHome={true}
            menuId={menuId}
          />
        </div>
      ) : null} */}

      {showMiniVodDetail ? (
        <MiniVodDetail
          vodData={previewData.current}
          closeModal={() => {
            setShowMiniVodDetail(false);
          }}
          isLeft={isLeftRef.current}
          isRight={isRightRef.current}
        />
      ) : null}

      {/* {showMiniProgramDetail ? (
        <MiniProgramDetail
          programData={programPreviewData.current}
          closeModal={() => {
            setShowMiniProgramDetail(false);
          }}
          setRecordRefresh={(val) => {
            if (val) {
              let cnt = recordRefreshCounter;
              setRecordRefreshCounter(++cnt);
            }
          }}
          onSelectRecord={(item, isPlay) => {
            let obj = {};
            obj.record = item;
            obj.isPlay = isPlay;
            setSelectedRecord(obj);
          }}
        />
      ) : null} */}
    </main>
  );
};

export default Home;
